import { render, staticRenderFns } from "./UpdateImage.vue?vue&type=template&id=6e06aa9d&"
import script from "./UpdateImage.vue?vue&type=script&lang=js&"
export * from "./UpdateImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports